import type { TwoModesData } from '@/content/types';

export default function TwoModes(props: TwoModesData) {
  return (
    <section className="section-padding">
      <div className="container split-2col">
        <div>
          {props.eyebrow && <div style={{ fontSize: 14, marginBottom: 12 }}>{props.eyebrow}</div>}
          <h2 className="h-section">{props.title}</h2>
          <p style={{ marginTop: 24, color: '#222' }}>{props.body}</p>
          {props.cta && (
            <a href={props.cta.href} className="btn-primary" style={{ marginTop: 24 }}>
              {props.cta.label}
            </a>
          )}
        </div>
        <div className="modes-cards">
          {props.modes.map((m, i) => (
            <div key={i} style={{ padding: 24, background: '#f5f9ff', borderRadius: 16 }}>
              <h3 style={{ fontSize: 20, fontWeight: 700 }}>{m.title}</h3>
              <p style={{ color: 'var(--color-muted)', marginTop: 8 }}>{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
